import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { FaEdit } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import "../../commoncss/Common.css";
import { useToast } from "../../commoncomponents/ToastProvider";
import Loader from "../../commoncomponents/Loader";

const Subadmins = () => {
  const [getSubadmin, setSubadmin] = useState({});
  const [getSubadminList, setSubadminList] = useState([{}]);
  const [getViewpopuplead, setViewpopuplead] = useState("");
  const [loading, setLoading] = useState(false);
  const cookie = new Cookies();
  const { showToast } = useToast();

  const create_subadmin = async () => {
    // Validate required fields
    if (!getSubadmin.name || !getSubadmin.email || !getSubadmin.phone || !getSubadmin.password) {
      showToast("Please fill in all required fields (Name, Email, Phone, Password)", "error");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(getSubadmin.email)) {
      showToast("Please enter a valid email address", "error");
      return;
    }

    // Validate phone number
    if (isNaN(getSubadmin.phone) || getSubadmin.phone <= 0) {
      showToast("Please enter a valid phone number", "error");
      return;
    }

    // Validate password length
    if (getSubadmin.password.length < 6) {
      showToast("Password must be at least 6 characters long", "error");
      return;
    }

    setLoading(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/newsubadmin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin"), ...getSubadmin }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          showToast("Created subadmin successfully", "success");
          setSubadmin({});
          search_subadmin();
        } else {
          showToast(dataset.err.msg || "Bad Authorization request", "error");
        }
      } else {
        showToast("Failed to create subadmin, try again", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Request failed, network error", "error");
    } finally {
      setLoading(false);
    }
  };

  const search_subadmin = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/subadmin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin") }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          setSubadminList(dataset.data.data);
        } else {
          showToast(dataset.err.msg || "Failed to search subadmin", "error");
        }
      } else {
        showToast("Failed to get subadmin list, try again", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Failed to get subadmin list or network error", "error");
    } finally {
      setLoading(false);
    }
  };

  const modify_subadmin = async (updates, subadminId) => {
    // Validate name if being updated
    if (updates.name !== undefined && !updates.name.trim()) {
      showToast("Name cannot be empty", "error");
      return;
    }

    // Validate email format if being updated
    if (updates.email !== undefined) {
      if (!updates.email.trim()) {
        showToast("Email cannot be empty", "error");
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(updates.email)) {
        showToast("Please enter a valid email address", "error");
        return;
      }
    }

    // Validate phone if being updated
    if (updates.phone !== undefined) {
      if (isNaN(updates.phone) || updates.phone <= 0) {
        showToast("Please enter a valid phone number", "error");
        return;
      }
    }

    // Validate password length if being updated
    if (updates.password !== undefined && updates.password.trim()) {
      if (updates.password.length < 6) {
        showToast("Password must be at least 6 characters long", "error");
        return;
      }
    }

    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/editsubadmin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          updates: updates,
          subadmin_id: subadminId,
        }),
      });
      const dataset = await resp.json();
      if (resp.status === 200) {
        if (dataset.status === true) {
          setViewpopuplead("");
          showToast("Updated successfully", "success");
          search_subadmin();
        } else {
          showToast(dataset.err.msg || "Failed to update subadmin, try again", "error");
        }
      } else {
        showToast(`Request failed, ${resp.status}, try later`, "error");
      }
    } catch (error) {
      console.log("Failed to update subadmin", error);
      showToast(
        "Network or server errror, please try after some time",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const PopupLead = () => {
    if (getViewpopuplead !== "") {
      const currentSubadmin = getSubadminList.find(subadmin => subadmin.id === getViewpopuplead);
      
      return (
        <>
          <div
            className="parentPopup"
            onClick={(e) => {
              setViewpopuplead("");
            }}
          ></div>
          <div className="childPopup">
            <div className="cancel_icon_container">
              <MdCancel
                className="cancel_icon"
                onClick={() => setViewpopuplead("")}
              />
            </div>
            <table>
              <tbody>
                <tr>
                  <td>Name : </td>
                  <td>
                    <input 
                      id="edit_name" 
                      name="name" 
                      defaultValue={currentSubadmin?.name || ""}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Email : </td>
                  <td>
                    <input 
                      id="edit_email" 
                      name="email" 
                      defaultValue={currentSubadmin?.email || ""}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Phone : </td>
                  <td>
                    <input 
                      id="edit_phone" 
                      name="phone" 
                      type="number"
                      defaultValue={currentSubadmin?.phone || ""}
                    />
                  </td>
                </tr>
                <tr>
                  <td>New Password</td>
                  <td>
                    <input
                      id="newpassword"
                      type="password"
                      name="password"
                      placeholder="Enter New Password (optional)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              className="btn_container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "10px 0px",
                gap: "10px"
              }}
            >
              <button
                onClick={(ee) => {
                  ee.preventDefault();
                  const updates = {
                    name: document.getElementById("edit_name").value,
                    email: document.getElementById("edit_email").value,
                    phone: parseInt(document.getElementById("edit_phone").value)
                  };
                  const password = document.getElementById("newpassword").value;
                  if (password) {
                    updates.password = password;
                  }
                  modify_subadmin(updates, getViewpopuplead);
                }}
              >
                {loading ? <Loader loading={loading} /> : "Update Subadmin"}
              </button>
            </div>
          </div>
        </>
      );
    }
  };

  useEffect(() => {
    search_subadmin();
  }, []);

  return (
    <>
      <PopupLead />
      <div className="agent_wrapper">
        <div className="top_search_fields">
          <div className="fields_row">
            <div className="fields_item">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={getSubadmin.name || ""}
                placeholder="Enter Name"
                onChange={(e) => {
                  setSubadmin({
                    ...getSubadmin,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </div>
            <div className="fields_item">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={getSubadmin.email || ""}
                placeholder="Enter Email"
                onChange={(e) => {
                  setSubadmin({
                    ...getSubadmin,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </div>
            <div className="fields_item">
              <label>Phone *</label>
              <input
                type="number"
                name="phone"
                value={getSubadmin.phone || ""}
                placeholder="Enter Phone"
                onChange={(e) => {
                  setSubadmin({
                    ...getSubadmin,
                    [e.target.name]: parseInt(e.target.value) || "",
                  });
                }}
              />
            </div>
            <div className="fields_item">
              <label>Password *</label>
              <input
                type="password"
                name="password"
                value={getSubadmin.password || ""}
                placeholder="Enter password"
                onChange={(e) => {
                  setSubadmin({
                    ...getSubadmin,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className="btn_container">
            <button
              onClick={(e) => {
                e.preventDefault();
                create_subadmin();
              }}
            >
              {loading ? <Loader loading={loading} /> : "Create Subadmin"}
            </button>
          </div>
        </div>
        <div className="table_container">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              {getSubadminList.map((subadmin, index) => {
                return (
                  <tr key={subadmin.id || index}>
                    <td>{subadmin.name}</td>
                    <td>{subadmin.email}</td>
                    <td>{subadmin.phone}</td>
                    <td
                      onClick={() => {
                        setViewpopuplead(subadmin.id);
                      }}
                      style={{ fontSize: "23px", color: "#4b49ac", cursor: "pointer" }}
                    >
                      <FaEdit className="edit_icon" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Subadmins;